import { MarketingChannel } from "@redotech/redo-model/marketing";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const campaignTimelineItemSchema = z.object({
  _id: zExt.objectId(),
  teamId: zExt.objectId(),
  teamName: z.string(),
  name: z.string(),
  channel: createEnum(MarketingChannel),
  scheduledAt: z.date().nullish(),
  finishedAt: z.date().nullish(),
  failedAt: z.date().nullish(),
  recipientCount: z.number(),
});

export type CampaignTimelineItem = z.infer<typeof campaignTimelineItemSchema>;

export const getCampaignTimelineData = {
  name: "getCampaignTimelineData" as const,
  input: z.object({ startDate: z.date(), endDate: z.date() }),
  output: z.object({ campaigns: z.array(campaignTimelineItemSchema) }),
};
